import React from 'react';
import PropTypes from 'prop-types';
import { List, Col } from '@sm/wds-react';

export const Column = ({ children }) => {
  return (
    <Col className="sm-nav-submenu__col">
      <List transparent interactive>
        {children}
      </List>
    </Col>
  );
};

export default Column;

Column.propTypes = {
  children: PropTypes.node.isRequired,
};
